import React from "react";
import { useAppDispatch, useAppSelector } from "./core/redux/hooks";
import {
    clearAuthSlice,
    fetchingUserDetails,
    isAuthenticated,
    setIsAuthenticated,
    setUserDetails,
} from "./core/redux/authSlice";
import { AuthInterceptor } from "./core/interceptor/auth-interceptor";
import { AppRoutes } from "./core/routes/routes";
import { isLogin } from "./components/authService";
import ToastView from "./components/AppToast/Toast";
import AppLoader from "./components/Apploader/AppLoader";
import Navigationbar from "./components/Navigationbar/Navigationbar";
import { showToaster } from "./core/redux/toastSlice";
import { GetApiMethod } from "./core/services/apiService";
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
    AuthInterceptor();
    let authState = useAppSelector((state) => state.auth);
    const authenticated = useAppSelector(isAuthenticated);
    const dispatch = useAppDispatch();
    let fetchingUserData = React.useRef<boolean>(false);

    const fetchUserDetails = React.useCallback(() => {
        dispatch(fetchingUserDetails(true));
        GetApiMethod('admin/user/profile')
            .then((res) => {
                console.log(res);
                dispatch(fetchingUserDetails(false));
                dispatch(setIsAuthenticated(true));
                if (res && res.data && res.data.user) {
                    dispatch(setUserDetails(res && res.data && res.data.user));
                }
            })
            .catch((err) => {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: err.response.data.message ? err.response.data.message : 'Unauthorized',
                        showDialog: true,
                        timer: '5000'
                    }
                ));
            });
    }, []);

    React.useEffect(() => {
        if (isLogin()) {
            if (!fetchingUserData.current) {
                fetchingUserData.current = true;
                fetchUserDetails();
            }
        } else {
            dispatch(fetchingUserDetails(false));
            localStorage.clear();
            dispatch(clearAuthSlice());
        }
    }, []);


    return (
        <>  
            {authenticated && <Navigationbar />}
            {authState.loading ? <AppLoader /> : <AppRoutes />}
            <ToastView />
        </>
    );
}

export default App;
